import React, { memo } from "react";
import TimelineItem from "./TimeLineItem/TimeLineItem";
import "../TimeLine/TimeLineItem/style.less";
import IntlMessages from "@util/IntlMessages";
import { Spin } from "../BP2Components";

const TimeLine = ({ value, listData }) => {
   return (
      <div>
            <div className="gx-timeline-section gx-timeline-center">
               {listData ? (
                  listData.length > 0 ? (
                     listData.map((data, index) => (
                        <TimelineItem
                           key={index}
                           value={value}
                           listData={data}
                           color="primary"
                           styleName={index % 2 == 0 ? "gx-timeline-inverted" : ""}
                        >
                           <i className={`icon icon-${value.iconAttribute} gx-p-2`} />
                        </TimelineItem>
                     ))
                  ) : (
                     <h4>
                        <IntlMessages id={`${value.noDataInfoTranslationKey}`} />
                     </h4>
                  )
               ) : (
                  <Spin />
               )}
            </div>
      </div>
   );
};

export default memo(TimeLine);
